import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@store/store'
import { prop } from 'ramda'

import {
  ASSESSMENT_OFFENCE,
  ASSESSMENT_OFFENCE_ALL,
  ASSESSMENT_OFFENCE_CHANGE_STATUS,
  ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS,
  ASSESSMENT_OFFENCE_INVIGILATION_ALL,
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL,
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL,
  ASSESSMENT_OFFENCE_REPORT_ALL,
  ASSESSMENT_OFFENCE_REPORT_CREATE,
  ASSESSMENT_OFFENCE_REPORT_LIST,
  ASSESSMENT_OFFENCE_TYPE_ALL,
  GLOBAL_STATE,
  REPORT_MISCONDUCT,
} from '../constants/actionTypes'

const academicMisconductSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const assessmentOffenceListSelector = createSelector(
  academicMisconductSelector,
  data => data[ASSESSMENT_OFFENCE]
)

export const assessmentOffenceInvigilationAllSelector = createSelector(
  academicMisconductSelector,
  data => data[ASSESSMENT_OFFENCE_INVIGILATION_ALL]
)

export const invigilationConsultationsAllSelector = createSelector(
  academicMisconductSelector,
  data => data[ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL]
)

export const assessmentOffenceInvigilationMinutesAllSelector = createSelector(
  academicMisconductSelector,
  data => data[ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL]
)

export const assessmentOffenceStatusSelector = createSelector(
  academicMisconductSelector,
  data => data[ASSESSMENT_OFFENCE_CHANGE_STATUS]
)

export const assessmentOffenceAllSelector = createSelector(
  academicMisconductSelector,
  data => data[ASSESSMENT_OFFENCE_ALL]
)

export const assessmentOffenceReportAllSelector = createSelector(
  academicMisconductSelector,
  data => data[ASSESSMENT_OFFENCE_REPORT_ALL]
)

export const assessmentOffenceReportListSelector = createSelector(
  academicMisconductSelector,
  data => data[ASSESSMENT_OFFENCE_REPORT_LIST]
)

export const subjectBoardSelector = createSelector(
  academicMisconductSelector,
  data => data[ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS]
)

export const assessmentOffenceTypeAllSelector = createSelector(
  academicMisconductSelector,
  data => data[ASSESSMENT_OFFENCE_TYPE_ALL]
)

export const reportMisconductSelector = createSelector(academicMisconductSelector, data => data[REPORT_MISCONDUCT])

export const reportMisconductCreateSelector = createSelector(
  academicMisconductSelector,
  data => data[ASSESSMENT_OFFENCE_REPORT_CREATE]
)
